module.exports = __webpack_public_path__ + "front/img/p1.ef6854f4.jpg";